export default {
	$accessibility: {
		archived: "보관됨",
		present: "현재",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "수신자에게 숨김",
			hidden_from_sender: "발신자에게 숨김",
			private: "비공개",
			shared_with_custom: "맞춤 설정 공유",
			shared_with_everyone: "모두와 공유",
			shared_with_receiver: "수신자와 공유",
			shared_with_sender: "발신자와 공유",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB 저장소",
		limitMBStorage: "{limit}MB 저장소",
		limitUser: "{limit} 사용자",
		limitUsers: "{limit} 사용자들",
		renewAtPricePerUnit: "{currency}{price}마다 {unit}에서 갱신됨",
		unlimitedModule: "무제한 {module}",
		upToLimitModule: "{limit} {module}까지",
	},
	$company: {
		address: "코텍리 마할. 데니즐리 요루 불. 테크노파크 사이트 B 블록 No:4B Ic kapi No:14 멘테세 / 무글라, 터키",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sko!2str!4v1701805110461!5m2!1sko!2str",
		name: "슬러시 소프트웨어 주식회사",
		phoneNumber: "+90 (555) 444-33-22",
		slogan: "Antrego로 비즈니스를 가속화하세요. 배송 프로세스를 디지털 방식으로 안전하고 쉽게 관리하세요.",
	},
	$cookieBanner: {
		accept: "수락",
		decline: "거부",
		message:
			"분석 및 개인화된 콘텐츠 제공을 위해 쿠키 및 유사 기술을 사용합니다. '수락' 버튼을 클릭하면 이러한 기술 사용에 동의하는 것으로 간주됩니다.",
	},
	$country: {
		afghanistan: "아프가니스탄",
		aland: "올란드",
		albania: "알바니아",
		algeria: "알제리",
		american_samoa: "미국령 사모아",
		andorra: "안도라",
		angola: "앙골라",
		anguilla: "앵귈라",
		antarctica: "남극",
		antigua_and_barbuda: "앤티가 바부다",
		argentina: "아르헨티나",
		armenia: "아르메니아",
		aruba: "아루바",
		australia: "호주",
		austria: "오스트리아",
		azerbaijan: "아제르바이잔",
		bahamas: "바하마",
		bahrain: "바레인",
		bangladesh: "방글라데시",
		barbados: "바베이도스",
		belarus: "벨라루스",
		belgium: "벨기에",
		belize: "벨리즈",
		benin: "베냉",
		bermuda: "버뮤다",
		bhutan: "부탄",
		bolivia: "볼리비아",
		bonaire_sint_eustatius_and_saba: "보네르, 신트외스타티우스, 사바",
		bosnia_and_herzegovina: "보스니아 헤르체고비나",
		botswana: "보츠와나",
		bouvet_island: "부베섬",
		brazil: "브라질",
		british_indian_ocean_territory: "영국령 인도양 지역",
		british_virgin_islands: "영국령 버진 아일랜드",
		brunei: "브루나이",
		bulgaria: "불가리아",
		burkina_faso: "부르키나파소",
		burundi: "부룬디",
		cabo_verde: "카보베르데",
		cambodia: "캄보디아",
		cameroon: "카메룬",
		canada: "캐나다",
		cayman_islands: "케이맨 제도",
		central_african_republic: "중앙아프리카공화국",
		chad: "차드",
		chile: "칠레",
		china: "중국",
		christmas_island: "크리스마스섬",
		cocos_islands: "코코스 제도",
		colombia: "콜롬비아",
		comoros: "코모로스",
		congo_republic: "콩고공화국",
		cook_islands: "쿡 제도",
		costa_rica: "코스타리카",
		croatia: "크로아티아",
		cuba: "쿠바",
		curacao: "퀴라소",
		cyprus: "키프로스",
		czechia: "체코",
		denmark: "덴마크",
		djibouti: "지부티",
		dominica: "도미니카",
		dominican_republic: "도미니카 공화국",
		dr_congo: "콩고민주공화국",
		ecuador: "에콰도르",
		egypt: "이집트",
		el_salvador: "엘살바도르",
		equatorial_guinea: "적도 기니",
		eritrea: "에리트레아",
		estonia: "에스토니아",
		eswatini: "에스와티니",
		ethiopia: "에티오피아",
		falkland_islands: "포클랜드 제도",
		faroe_islands: "페로 제도",
		fiji: "피지",
		finland: "핀란드",
		france: "프랑스",
		french_guiana: "프랑스령 기아나",
		french_polynesia: "프랑스령 폴리네시아",
		french_southern_territories: "프랑스령 남방 및 남극 지역",
		gabon: "가봉",
		gambia: "감비아",
		georgia: "조지아",
		germany: "독일",
		ghana: "가나",
		gibraltar: "지브롤터",
		greece: "그리스",
		greenland: "그린란드",
		grenada: "그레나다",
		guadeloupe: "과들루프",
		guam: "괌",
		guatemala: "과테말라",
		guernsey: "건지섬",
		guinea: "기니",
		guinea_bissau: "기니비사우",
		guyana: "가이아나",
		haiti: "아이티",
		heard_island_and_mcdonald_islands: "허드섬 및 맥도널드 제도",
		honduras: "온두라스",
		hong_kong: "홍콩",
		hungary: "헝가리",
		iceland: "아이슬란드",
		india: "인도",
		indonesia: "인도네시아",
		iran: "이란",
		iraq: "이라크",
		ireland: "아일랜드",
		isle_of_man: "맨섬",
		israel: "이스라엘",
		italy: "이탈리아",
		ivory_coast: "코트디부아르",
		jamaica: "자메이카",
		japan: "일본",
		jersey: "저지섬",
		jordan: "요르단",
		kazakhstan: "카자흐스탄",
		kenya: "케냐",
		kiribati: "키리바시",
		kosovo: "코소보",
		kuwait: "쿠웨이트",
		kyrgyzstan: "키르기스스탄",
		laos: "라오스",
		latvia: "라트비아",
		lebanon: "레바논",
		lesotho: "레소토",
		liberia: "라이베리아",
		libya: "리비아",
		liechtenstein: "리히텐슈타인",
		lithuania: "리투아니아",
		luxembourg: "룩셈부르크",
		macao: "마카오",
		madagascar: "마다가스카르",
		malawi: "말라위",
		malaysia: "말레이시아",
		maldives: "몰디브",
		mali: "말리",
		malta: "몰타",
		marshall_islands: "마셜 제도",
		martinique: "마르티니크",
		mauritania: "모리타니",
		mauritius: "모리셔스",
		mayotte: "마요트",
		mexico: "멕시코",
		micronesia: "미크로네시아",
		moldova: "몰도바",
		monaco: "모나코",
		mongolia: "몽골",
		montenegro: "몬테네그로",
		montserrat: "몬트세랫",
		morocco: "모로코",
		mozambique: "모잠비크",
		myanmar: "미얀마",
		namibia: "나미비아",
		nauru: "나우루",
		nepal: "네팔",
		netherlands: "네덜란드",
		new_caledonia: "뉴칼레도니아",
		new_zealand: "뉴질랜드",
		nicaragua: "니카라과",
		niger: "니제르",
		nigeria: "나이지리아",
		niue: "니우에",
		norfolk_island: "노퍽섬",
		north_korea: "북한",
		north_macedonia: "북마케도니아",
		northern_mariana_islands: "북마리아나 제도",
		norway: "노르웨이",
		oman: "오만",
		pakistan: "파키스탄",
		palau: "팔라우",
		palestine: "팔레스타인",
		panama: "파나마",
		papua_new_guinea: "파푸아뉴기니",
		paraguay: "파라과이",
		peru: "페루",
		philippines: "필리핀",
		pitcairn_islands: "핏케언 제도",
		poland: "폴란드",
		portugal: "포르투갈",
		puerto_rico: "푸에르토리코",
		qatar: "카타르",
		reunion: "레위니옹",
		romania: "루마니아",
		russia: "러시아",
		rwanda: "르완다",
		saint_barthelemy: "생바르텔레미",
		saint_helena: "세인트헬레나",
		saint_lucia: "세인트루시아",
		saint_martin: "생마르탱",
		saint_pierre_and_miquelon: "생피에르 미클롱",
		samoa: "사모아",
		san_marino: "산마리노",
		sao_tome_and_principe: "상투메 프린시페",
		saudi_arabia: "사우디아라비아",
		senegal: "세네갈",
		serbia: "세르비아",
		seychelles: "세이셸",
		sierra_leone: "시에라리온",
		singapore: "싱가포르",
		sint_maarten: "신트마르턴",
		slovakia: "슬로바키아",
		slovenia: "슬로베니아",
		solomon_islands: "솔로몬 제도",
		somalia: "소말리아",
		south_africa: "남아프리카 공화국",
		south_georgia_and_south_sandwich_islands: "사우스조지아 및 사우스샌드위치 제도",
		south_korea: "대한민국",
		south_sudan: "남수단",
		spain: "스페인",
		sri_lanka: "스리랑카",
		st_kitts_and_nevis: "세인트키츠 네비스",
		st_vincent_and_grenadines: "세인트빈센트 그레나딘",
		sudan: "수단",
		suriname: "수리남",
		svalbard_and_jan_mayen: "스발바르 제도 및 얀마옌 제도",
		sweden: "스웨덴",
		switzerland: "스위스",
		syria: "시리아",
		taiwan: "대만",
		tajikistan: "타지키스탄",
		tanzania: "탄자니아",
		thailand: "태국",
		timor_leste: "동티모르",
		togo: "토고",
		tokelau: "토켈라우",
		tonga: "통가",
		trinidad_and_tobago: "트리니다드 토바고",
		tunisia: "튀니지",
		turkiye: "튀르키예",
		turkmenistan: "투르크메니스탄",
		turks_and_caicos_islands: "터크스 케이커스 제도",
		tuvalu: "투발루",
		uganda: "우간다",
		ukraine: "우크라이나",
		united_arab_emirates: "아랍에미리트",
		united_kingdom: "영국",
		united_states: "미국",
		uruguay: "우루과이",
		us_minor_outlying_islands: "미국령 군소 제도",
		us_virgin_islands: "미국령 버진 아일랜드",
		uzbekistan: "우즈베키스탄",
		vanuatu: "바누아투",
		vatican_city: "바티칸 시국",
		venezuela: "베네수엘라",
		vietnam: "베트남",
		wallis_and_futuna: "왈리스 푸투나",
		western_sahara: "서사하라",
		yemen: "예멘",
		zambia: "잠비아",
		zimbabwe: "짐바브웨",
	},
	$currency: {
		euro: "유로",
		turkish_lira: "터키 리라",
		us_dollar: "미국 달러",
	},
	$documentManager: {
		message_1: '템플릿을 편집하려면 "템플릿 편집" 버튼을 클릭하여 편집 화면으로 이동하세요.',
		message_2: '목록의 행 수를 늘리거나 줄이려면 "행 수"를 조정하세요.',
		message_3: '콘텐츠 필드에서 변경한 내용은 "미리보기" 섹션에 즉시 반영됩니다.',
		message_4: 'PDF를 생성하려면 "문서 작업" 버튼을 클릭하여 PDF로 저장하세요.',
		message_5: '나중에 문서에 액세스하려면 "문서 작업" 버튼을 통해 저장할 수 있습니다.',
		message_6: "표의 각 셀에 입력된 데이터는 미리보기에 그대로 반영됩니다.",
		message_7: "데이터 표는 Excel 시트나 전자 스프레드시트처럼 편집할 수 있습니다.",
	},
	$employeeType: {
		admin: "관리자",
		default: "기본",
		exporter: "수출자",
		importer: "수입자",
	},
	$format: {
		date: "YYYY.MM.DD",
		date_time: "YYYY.MM.DD HH:mm:ss",
		date_time_without_second: "YYYY.MM.DD HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "여기에서 회사를 만드세요.",
			create_company_title: "회사를 추가하시겠습니까?",
			description: "성공적으로 로그인되었습니다. 이제 회사를 가입하거나 새 회사를 만드세요.",
			join_company_subtitle: "코드를 입력하고 여기에서 회사를 가입하세요.",
			join_company_title: "기존 회사에 가입하시겠습니까?",
			title: "환영합니다 {name}",
		},
		$unauthorized: {
			description: "Antrego를 사용하여 수출입 프로세스를 관리하세요.",
			forget_password_subtitle: "비밀번호를 재설정하려면 이메일을 입력하세요.",
			sign_in_subtitle: "여기에서 로그인하세요",
			sign_in_title: "이미 계정이 있으신가요?",
			sign_up_subtitle: "여기에서 가입하세요",
			sign_up_title: "계정을 만들고 싶으신가요?",
			title: "Antrego에 오신 것을 환영합니다",
		},
	},
	$invitationType: {
		company_partner: "상업적 협력 초대",
		customs_partner: "세관 협력 초대",
		employee: "직원 초대",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "비즈니스 운영을 변혁하세요",
				hero_subtitle: "플랫폼의 이점",
				hero_description:
					"Antrego가 재고 관리부터 선적 추적까지 전체 물류 워크플로를 어떻게 간소화하는지 알아보세요. 조직 전반의 효율성 향상, 비용 절감, 협업 강화 효과를 경험하십시오.",
				features_title: "종합적인 플랫폼 이점",
				feature_1_title: "중앙화 대시보드",
				feature_1_desc: "단일하고 직관적인 인터페이스에서 모든 물류 데이터, 선적, 재고 및 문서에 접근하세요.",
				feature_2_title: "데이터 정확도 향상",
				feature_2_desc: "자동 데이터 입력, 검증, 실시간 동기화를 통해 오류를 최소화하세요.",
				feature_3_title: "시간 효율성",
				feature_3_desc: "자동화된 워크플로, 스마트 알림, 간소화된 프로세스로 매일 수 시간을 절약하세요.",
				feature_4_title: "팀 협업",
				feature_4_desc: "내부 팀, 고객, 공급업체, 물류 파트너 간 원활한 협업을 가능하게 합니다.",
				feature_5_title: "비용 절감",
				feature_5_desc: "효율성 향상, 오류 감소, 자원 배분 최적화를 통해 운영 비용을 줄이세요.",
				feature_6_title: "확장성",
				feature_6_desc: "필요에 따라 손쉽게 확장되는 플랫폼으로 자신 있게 비즈니스를 성장시키세요.",
				benefits_title: "왜 Antrego인가요?",
				benefit_1: "공급망 전반에 걸친 완전한 가시성",
				benefit_2: "엔터프라이즈급 암호화를 갖춘 안전한 클라우드 기반 플랫폼",
				benefit_3: "이동 중에도 접근 가능한 반응형 모바일 디자인",
				benefit_4: "모든 이해관계자에게 정보를 제공하는 자동 알림",
				benefit_5: "비즈니스 프로세스에 맞춰 조정 가능한 맞춤형 워크플로",
				benefit_6: "성공을 보장하는 전담 지원팀",
				workflow_title: "Antrego가 운영을 바꾸는 방법",
				step_1_title: "운영 통합",
				step_1_desc: "재고 관리, 선적 추적, 문서 처리, 고객 커뮤니케이션을 하나의 통합 플랫폼으로 묶으세요.",
				step_2_title: "반복 작업 자동화",
				step_2_desc:
					"데이터 입력, 알림, 상태 업데이트와 같은 반복 작업을 Antrego에 맡기고 팀은 전략 업무에 집중하세요.",
				step_3_title: "실시간 협업 활성화",
				step_3_desc: "모든 이해관계자와 정보를 즉시 공유하여 최신 업데이트와 문서에 모두가 접근할 수 있게 합니다.",
				step_4_title: "데이터 기반 의사결정",
				step_4_desc: "종합 분석과 보고를 활용해 트렌드를 파악하고 프로세스를 최적화하며 지속적 개선을 추진하세요.",
				cta_title: "물류 운영을 변혁할 준비가 되셨나요?",
				cta_button: "지금 무료로 시작하기",
				cta_subtitle: "신용카드 불필요 • 500개 이상 기업이 선택",
			},
			benefits_title: "플랫폼의 이점",
			business_process: "비즈니스 프로세스를 가속화합니다.",
			control_title: "Antrego로 제어를 확보하세요.",
			highlight_word: "제어",
			risk_of_error: "오류의 위험을 줄입니다.",
			text: "Antrego는 재고 관리, 실시간 선적 추적, 문서 자동화 등 엔드 투 엔드 디지털 솔루션으로 수출업자, 수입업자, 포워더, 제조사의 물류 운영을 혁신합니다.",
			time_and_cost_savings: "시간과 비용을 절감합니다.",
		},
		$content: {
			$text: {
				0: "모든 배송을 한 곳에서 추적하고, 동적 보고로 재정을 관리하세요.",
				1: "실시간 업데이트를 고객과 공유하여 서비스 품질을 향상시키세요.",
				2: "배송과 관련된 모든 문서를 하나의 시스템에서 보고 공유하세요.",
				3: "모든 장치 및 위치에서 Antrego에 액세스하여 프로세스를 쉽게 관리하세요.",
				4: "SHA-256 암호화 기술을 사용하여 모든 데이터를 저장하세요. 보안에 대한 걱정은 없습니다.",
				5: "비즈니스 프로세스의 모든 이해관계자와 공동으로 추적에 참여하세요. 더 효율적으로 프로세스를 관리하세요.",
			},
			$title: {
				0: "엔드 투 엔드 선적 관리",
				1: "실시간 고객 커뮤니케이션",
				2: "중앙화된 문서 관리",
				3: "클라우드 기반 어디서나 접근",
				4: "엔터프라이즈급 보안",
				5: "다자 간 협업",
			},
			content_title: "하나의 플랫폼에 모든 기능을",
		},
		$home: {
			subtitle: "재고, 선적, 문서, 추적을 하나의 강력한 플랫폼에서 관리",
			text: "자동화된 워크플로로 운영 시간을 40% 절감하세요. 전 세계 500개 이상의 기업이 물류 운영을 간소화하고 있습니다.",
			title: "재고부터 배송까지: 완전한 물류 플랫폼",
		},
		$lifecycle: {
			headline: "프로세스",
			info_button: "정보 얻기",
			lifecycle_texts: {
				0: "추가 파일을 업로드하여 견적서를 작성하고 고객과 즉시 공유하세요.",
				1: "배송 세부 정보를 입력하고 문서를 추가하세요. 고객에게 알리고 하나의 채널을 통해 공동으로 모든 배송 프로세스를 관리하세요.",
				2: "수입 및 수출과 관련된 재정 상황을 실시간으로 추적하세요.",
			},
			lifecycle_titles: {
				0: "로그인 및 견적서 작성",
				1: "배송 생성",
				2: "재정 활동 추적",
			},
			productivity_title: "3단계로 생산성 향상 및 복잡성 및 오류 감소",
			tracking_guide_title: "쉬운 추적 가이드",
		},
		$logistics: {
			logistics_title: "지원되는 물류 유형",
			solutions_title: "모든 화물에 맞는 솔루션",
			text: "모든 유형의 운송에서 디지털 파트너 Antrego와 함께 모든 글로벌 이동에서 여러분의 곁에 있습니다.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "전문 PDF 문서 제작",
				hero_subtitle: "몇 분 만에 멋진 상업 문서를 생성",
				hero_description:
					"Antrego의 직관적인 PDF 생성기는 손쉬운 디자인, 맞춤화, 생성 기능으로 송장, 프로포마 인보이스 및 상업 문서를 손쉽게 만들 수 있게 해줍니다. 디자인 기술은 필요 없습니다.",
				features_title: "전문 문서 생성을 위한 모든 것",
				feature_1_title: "드래그 앤 드롭 에디터",
				feature_1_desc:
					"텍스트, 이미지, 로고, 표를 간단한 드래그 앤 드롭으로 추가하는 직관적인 인터페이스. 기술 지식이 필요 없습니다.",
				feature_2_title: "맞춤 템플릿",
				feature_2_desc:
					"사전 디자인된 템플릿을 선택하거나 고유한 브랜드 레이아웃을 만드세요. 템플릿을 저장하여 일관된 브랜딩을 유지하세요.",
				feature_3_title: "스마트 폼 필드",
				feature_3_desc: "고객 정보, 제품 상세, 가격을 자동으로 채웁니다. 선적 및 재고 데이터와 직접 연동됩니다.",
				feature_4_title: "브랜드 커스터마이징",
				feature_4_desc:
					"회사 로고 추가, 브랜드 색상 선택, 글꼴 커스터마이징으로 비즈니스 아이덴티티를 완벽히 반영한 문서를 만드세요.",
				feature_5_title: "다양한 형식으로 내보내기",
				feature_5_desc:
					"PDF로 다운로드, 바로 인쇄, 이메일로 공유까지. 모든 문서는 전문적으로 서식 지정되어 인쇄 준비가 완료되어 있습니다.",
				feature_6_title: "버전 관리",
				feature_6_desc:
					"문서 수정을 추적하고 이력을 유지하며 이전 버전에 접근하세요. 중요한 버전을 잃어버릴 일이 없습니다.",
				benefits_title: "왜 Antrego PDF 생성기인가요?",
				benefit_1: "기존 방식보다 10배 더 빠르게 전문 문서 생성",
				benefit_2: "모든 상업 문서에서 일관된 브랜딩 유지",
				benefit_3: "선적 데이터에서 자동으로 값이 채워져 오류 감소",
				benefit_4: "재사용 가능한 템플릿과 스마트 폼으로 시간 절약",
				benefit_5: "세련되고 전문적인 문서로 고객에게 깊은 인상",
				benefit_6: "언제 어디서나 어떤 기기에서든 문서 접근",
				workflow_title: "PDF 생성 과정",
				step_1_title: "템플릿 선택",
				step_1_desc: "사전 제작된 템플릿 중에서 선택하거나 빈 캔버스에서 맞춤 레이아웃을 만드세요.",
				step_2_title: "콘텐츠 커스터마이징",
				step_2_desc: "요소를 드래그 앤 드롭하고 로고와 브랜딩을 추가하며 선적 데이터로 필드를 자동 채우세요.",
				step_3_title: "미리보기 및 편집",
				step_3_desc: "실시간으로 문서를 검토하고 조정하여 생성 전 완벽한 상태를 보장하세요.",
				step_4_title: "생성 및 공유",
				step_4_desc:
					"PDF로 다운로드하거나 고객에게 직접 이메일 전송, 선적에 첨부하세요. 템플릿을 저장해 두고 재사용할 수 있습니다.",
				cta_title: "지금 바로 전문 문서를 만들어 보세요",
				cta_button: "무료로 시작하기",
				cta_subtitle: "신용카드 불필요 • 몇 분 안에 시작",
			},
			description:
				"우리의 PDF 편집기는 청구서를 작성하고 편집하는 것을 더욱 실용적으로 만들어주는 강력한 도구입니다. 시간을 절약하고 비즈니스 파트너에게 전문적인 문서를 제공합니다.",
			features: {
				design: "청구서 디자인: 로고를 추가하고 색상을 조정하며 청구서 형식을 맞춤화하세요.",
				edit: "문서 편집: PDF를 빠르게 편집하고 텍스트를 추가하거나 제거하세요.",
				shareSave: "공유 및 저장: 생성된 문서를 다운로드하고 공유하거나 플랫폼에서 직접 저장하세요.",
			},
			longTitle: "PDF 편집기로 빠르고 맞춤형 청구서 작성.",
			note: "이 설정을 통해 사용자는 기능을 시각적으로 탐색하고 서면으로 장점을 검토할 수 있습니다.",
			title: "청구서 작성이 너무 쉬워졌습니다!",
		},
		$process: {
			comparison_subtitle: "전통적 방식과 디지털 물류 관리의 차이를 비교해 보세요",
			digital_future: "전통적인 방법에서 벗어나 디지털 미래로 나아가세요",
			digital_shipping: "Antrego로 디지털 배송 추적",
			digital_shipping_texts: {
				0: "들어오는 주문에 대한 견적서는 하나의 채널을 통해 쉽게 생성 및 추적됩니다.",
				1: "견적서가 전송되면 고객에게 즉시 알림이 전송되며, Antrego에서 승인됩니다.",
				2: "문서 프로세스는 Antrego를 통해 관리됩니다. 분실되지 않고, 지연이 발생하지 않으며 오류 가능성이 최소화됩니다.",
				3: "공급업체, 고객 및 세관 중개인은 배송 세부 정보를 즉시 보고 공동으로 추적할 수 있습니다.",
				4: "재정 보고서는 매월 및 매년 자동으로 생성됩니다.",
			},
			question_title: "Antrego가 주당 10시간 이상을 절약해 드리는 방법",
			tracking_method: "추적 방법을 디지털화하여 프로세스를 가속화하세요.",
			traditional_shipping: "전통적인 배송 추적",
			traditional_shipping_texts: {
				0: "주문은 이메일, 메시지 또는 전화를 통해 다양한 채널로 수집되어 내부 추적에 어려움이 발생합니다.",
				1: "견적서는 Excel과 같은 도구를 사용하여 작성되고, 승인 과정은 이메일, WhatsApp 또는 전화를 통해 수동으로 처리됩니다.",
				2: "수동 문서 프로세스는 오류와 지연을 초래하여 시간과 재정적 손실을 발생시킵니다.",
				3: "공급업체, 고객, 세관 중개인이 배송 세부 정보를 추적할 수 있는 공통 플랫폼이 없습니다.",
				4: "배송 후 재정 데이터를 개별적으로 확인하여 보고서 작성이 어렵습니다.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego는 기업이 선적을 추적하고 재고를 관리하며 고객과 실시간으로 협업할 수 있도록 돕는 종합 물류 관리 플랫폼입니다. 재고에서 배송까지 전체 공급망 프로세스를 디지털화합니다.</p>",
				1: "<p>Antrego는 어떤 기기에서든 손쉽게 접근할 수 있는 Easy Access, SHA-256 암호화를 사용하는 엔터프라이즈급 Data Security, 그리고 모든 이해관계자에게 선적 진행 상황을 알려주는 Joint Tracking을 통해 물류를 간소화합니다.</p>",
				2: "<p>Antrego는 해상 운송, 항공 화물, 육상 운송, 철도 물류 등 주요 운송 모드를 모두 지원합니다. 전 세계 주요 운송사 및 선사와 함께합니다.</p>",
				3: "<p>Antrego는 월 최대 10건의 선적까지 무료 요금을 제공하며 신용카드가 필요하지 않습니다. 프리미엄 플랜은 무제한 선적 기준 월 $99부터 시작하며, 연간 결제 시 16%를 절약할 수 있습니다. 자세한 내용은 가격 페이지를 참고하세요.</p>",
				4: "<p>인기 물류 및 ERP 시스템과의 API 액세스 및 통합 기능을 현재 개발 중입니다. 통합 기능은 향후 릴리스에 포함될 예정입니다. 로드맵과 예정 기능에 대해 더 알고 싶다면 문의하세요.</p>",
				5: "<p>대부분의 회사는 24시간 이내에 운영을 시작합니다. 기본 설정은 계정 생성과 회사 정보 추가에 5~10분이면 충분합니다. 온보딩 팀이 데이터 가져오기와 워크플로 커스터마이징을 도와드립니다.</p>",
			},
			$title: {
				0: "Antrego란 무엇인가요?",
				1: "왜 Antrego를 사용해야 하나요?",
				2: "Antrego는 어떤 물류를 지원하나요?",
				3: "Antrego의 비용은 얼마인가요?",
				4: "기존 시스템과 Antrego를 통합할 수 있나요?",
				5: "Antrego 설정에는 얼마나 걸리나요?",
			},
			save_percentage: "매월 16% 절약",
			text: "Antrego를 사용하여 모든 정보를 쉽게 액세스하고, 추가 문의가 있는 경우 언제든지 문의하세요.",
			title: "궁금한 모든 것을 신속하게 배워보세요",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "재고 관리를 변혁하세요",
				hero_subtitle: "재고부터 판매까지—제품 라이프사이클을 디지털로 관리",
				hero_description:
					"Antrego의 재고 관리 기능은 수출업자와 제조사가 단일 통합 플랫폼에서 재고를 효율적으로 관리하고, 고객과 제품 카탈로그를 공유하며, 판매 프로세스를 가속화하도록 돕습니다.",
				features_title: "강력한 재고 관리 기능",
				feature_1_title: "중앙화 재고 관리",
				feature_1_desc:
					"단일 대시보드에서 모든 재고 항목을 관리하세요. 수량, 로트 번호, 창고, 제품 세부 정보를 손쉽게 추적합니다.",
				feature_2_title: "공개 재고 카탈로그",
				feature_2_desc:
					"전 세계 잠재 고객에게 제공할 수 있는 공개 카탈로그 페이지를 생성하세요. 간단한 링크로 재고를 공유할 수 있습니다.",
				feature_3_title: "배치(로트) 추적",
				feature_3_desc:
					"정확한 재고 관리를 위해 수량, 치수, 사용자 정의 속성 등 상세 정보와 함께 개별 재고 배치를 추적합니다.",
				feature_4_title: "다중 창고 지원",
				feature_4_desc:
					"여러 창고와 위치에 걸쳐 재고를 구성하세요. 각 제품의 보관 위치를 정확히 파악해 효율적인 물류를 실현합니다.",
				feature_5_title: "제품 이미지 갤러리",
				feature_5_desc: "각 재고 항목에 여러 이미지를 업로드하여 고객과 팀에게 시각적 명확성을 제공합니다.",
				feature_6_title: "재고에서 바로 선적으로",
				feature_6_desc:
					"재고 항목을 선적으로 원활하게 전환하세요. 재고에서 직접 프로포마 인보이스와 선적 문서를 생성합니다.",
				benefits_title: "왜 Antrego 재고 관리인가요?",
				benefit_1: "제품의 글로벌 바이어 노출 극대화",
				benefit_2: "수동 재고 추적에 소요되는 시간 절감",
				benefit_3: "재고에서 판매까지 전환 간소화",
				benefit_4: "고객에게 실시간 재고 정보 제공",
				benefit_5: "15개 이상의 언어 지원으로 국제 시장 대응",
				benefit_6: "선적 및 청구 시스템과 통합",
				workflow_title: "작동 방식",
				step_1_title: "제품 추가",
				step_1_desc: "제품 상세, 수량, 창고, 이미지 등 세부 정보를 포함해 재고 항목을 생성하세요.",
				step_2_title: "카탈로그 공유",
				step_2_desc: "잠재 고객이 언제든지 볼 수 있는 재고 카탈로그 공개 링크를 생성하세요.",
				step_3_title: "문의 수신",
				step_3_desc: "고객이 사용 가능한 제품을 확인하고 주문 및 견적을 위해 직접 문의할 수 있습니다.",
				step_4_title: "판매로 전환",
				step_4_desc: "재고 항목에서 손쉽게 프로포마 인보이스와 선적을 생성하여 고객 주문을 이행하세요.",
				cta_title: "재고 관리를 현대화할 준비가 되셨나요?",
				cta_button: "무료로 시작하기",
				cta_subtitle: "신용카드 불필요 • 몇 분 만에 설정 완료",
			},
			access_potential_customers: "잠재 고객에게 빠르게 접근하세요",
			desc: "수출업자와 제조업자를 위해 특별히 설계된 Antrego는 귀하의 판매 및 마케팅 프로세스를 가속화합니다. 재고 관리, 고객 재고 공유 및 배송 관리로 비즈니스를 성장시키세요!",
			global_market: "15개 언어 지원으로 글로벌 시장에 진출하세요",
			main_title: "영업 및 마케팅을 위한 차세대 솔루션",
			manage_stocks: "재고를 즉시 관리하고 공유하세요",
			speed_up_sales: "판매 프로세스를 가속화하세요",
			title: "재고에서 판매로",
		},
		$tracking: {
			$detailPage: {
				hero_title: "실시간 선적 추적",
				hero_subtitle: "모든 컨테이너를, 모든 단계에서 모니터링",
				hero_description:
					"Antrego의 고급 추적 시스템은 실시간 업데이트, 자동 알림, 포괄적인 상태 보고로 선적에 대한 완전한 가시성을 제공합니다. 컨테이너를 다시는 놓치지 마세요.",
				features_title: "완전한 추적 솔루션",
				feature_1_title: "실시간 컨테이너 추적",
				feature_1_desc: "모든 선적에 대해 정확한 위치 업데이트와 도착 예정 시간을 실시간으로 확인하세요.",
				feature_2_title: "자동 알림",
				feature_2_desc: "상차, 출발, 도착, 통관, 배송 완료 등 중요한 이정표에 대한 즉시 알림을 받으세요.",
				feature_3_title: "상태 이력",
				feature_3_desc: "모든 이동, 상태 변경, 주요 이벤트의 상세 로그와 함께 전체 선적 이력에 접근하세요.",
				feature_4_title: "다자(멀티) 이해관계자 가시성",
				feature_4_desc: "고객, 공급업체, 통관사와 추적 정보를 공유하세요. 모두가 자동으로 정보를 받습니다.",
				feature_5_title: "문서 관리",
				feature_5_desc: "선하증권, 통관 서류, 각종 증명서를 포함한 모든 선적 문서를 한 곳에 첨부하고 접근하세요.",
				feature_6_title: "지연 알림",
				feature_6_desc: "잠재적 지연이나 문제를 선제적으로 알림 받아 문제가 커지기 전에 조치할 수 있습니다.",
				benefits_title: "왜 Antrego 추적인가요?",
				benefit_1: "셀프 서비스 추적으로 고객 문의 감소",
				benefit_2: "선제적 모니터링과 알림으로 비용이 큰 지연 예방",
				benefit_3: "투명한 커뮤니케이션으로 고객 만족도 향상",
				benefit_4: "모든 이해관계자에게 자동 상태 업데이트 제공으로 시간 절약",
				benefit_5: "실시간 가시성으로 위험 최소화",
				benefit_6: "브랜드 이미지를 향상시키는 전문 추적 페이지",
				workflow_title: "추적 작동 방식",
				step_1_title: "선적 생성",
				step_1_desc: "컨테이너 번호, 경로, 예정 일정을 포함한 선적 세부 정보를 시스템에 입력합니다.",
				step_2_title: "자동 업데이트",
				step_2_desc: "시스템이 자동으로 컨테이너를 추적하고 각 체크포인트를 지날 때 상태를 업데이트합니다.",
				step_3_title: "이해관계자 알림",
				step_3_desc: "중요 이정표와 상태 변경에 대한 즉시 알림을 모든 당사자가 받습니다.",
				step_4_title: "배송 확인",
				step_4_desc: "완전한 문서와 선적 이력과 함께 최종 배송 확인을 받으세요.",
				cta_title: "안심하고 선적을 추적하세요",
				cta_button: "무료로 시작하기",
				cta_subtitle: "신용카드 불필요 • 지금 바로 추적 시작",
			},
			control_title: "Antrego로 배송을 제어하세요.",
			real_time_alerts: "실시간 알림: 모든 컨테이너에 대한 즉각적인 알림과 전체 상태 업데이트를 받으세요.",
			secure_data_handling: "안전한 데이터 처리: 배송 데이터를 플랫폼에서 직접 쉽게 다운로드, 공유 또는 저장하세요.",
			tracking_description:
				"Antrego의 컨테이너 추적 솔루션은 실시간으로 배송을 빠르고 효율적으로 모니터링하는 방법을 제공합니다. 상세하고 전문적인 업데이트로 배송을 제어하고 파트너에게 인상적인 서비스를 제공하세요.",
			tracking_title: "쉽게 배송을 추적하세요!",
		},
		cancel_anytime: "언제든지 취소 가능",
		customize_package: "추가 스토리지 및 사용자를 구매하여 패키지를 필요에 맞게 사용자 정의할 수 있습니다",
		free_features_1: "10회 배송",
		free_features_2: "100MB 저장소",
		free_features_3: "무제한 상업 파트너",
		free_features_4: "1 사용자",
		free_plan: "무료",
		free_price: "$0",
		free_regeneration: "",
		free_title: "월간",
		premium_annual_features_1: "20 사용자",
		premium_annual_features_2: "100 파트너",
		premium_annual_features_3: "1000회 배송",
		premium_annual_features_4: "1000 인보이스",
		premium_annual_price: "$83.25",
		premium_annual_regeneration: "$999에서 매년 갱신됩니다.",
		premium_annual_title: "연간",
		premium_monthly_features_1: "무제한 배송",
		premium_monthly_features_2: "무제한 상업 파트너",
		premium_monthly_features_3: "2GB 저장소",
		premium_monthly_features_4: "3 사용자",
		premium_monthly_price: "$99",
		premium_monthly_regeneration: "$99에서 매월 갱신됩니다.",
		premium_monthly_title: "월간",
		premium_plan: "프리미엄 플랜",
		premium_plus_annual_features_1: "무제한 배송",
		premium_plus_annual_features_2: "무제한 상업 파트너",
		premium_plus_annual_features_3: "5GB 저장소",
		premium_plus_annual_features_4: "5 사용자",
		premium_plus_annual_price: "$83.25",
		premium_plus_annual_regeneration: "$999에서 매년 갱신됩니다.",
		premium_plus_annual_title: "연간",
		premium_plus_monthly_features_1: "무제한 배송",
		premium_plus_monthly_features_2: "무제한 상업 파트너",
		premium_plus_monthly_features_3: "5GB 저장소",
		premium_plus_monthly_features_4: "5 사용자",
		premium_plus_monthly_price: "$249",
		premium_plus_monthly_regeneration: "$249에서 매월 갱신됩니다.",
		premium_plus_monthly_title: "월간",
		premium_plus_plan: "프리미엄 플러스",
		pricing_text: "예산을 초과하지 않으면서 가장 적합한 솔루션을 제공합니다.",
		pricing_title: "Antrego는 고객에게 최고의 패키지와 가격을 보장합니다.",
		save_percentage: "매월 16% 절약",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "아랍어",
		de: "독일어",
		en: "영어",
		es: "스페인어",
		fr: "프랑스어",
		hi: "힌디어",
		ind: "인도네시아어",
		it: "이탈리아어",
		ja: "일본어",
		ko: "한국어",
		pt: "포르투갈어",
		ru: "러시아어",
		tr: "터키어",
		vi: "베트남어",
		zh: "중국어",
	},
	$message: {
		cannot_delete_verified_partner: "인증된 파트너는 삭제할 수 없습니다.",
		confirm: "{function}을(를) 확실히 하시겠습니까?",
		created: "{item} 생성됨.",
		deleted: "{item} 삭제됨.",
		edited: "{item} 편집됨.",
		error_on_view_file: "파일을 보는 동안 오류가 발생했습니다.",
		file_oversize: "파일 크기는 최대 {size}여야 합니다.",
		invalid: "유효하지 않은 {item}",
		migrated: "{item} 이동됨. ({value})",
		process_has_been_started: "{item}이(가) 시작되었습니다.",
		saved: "{item} 저장됨.",
		sent: "{item} 전송됨.",
		sent_email: "이메일 전송됨. ({value})",
		sign_in_failed: "이메일 또는 비밀번호가 잘못되었습니다.",
		unsupported_file_type: "지원되지 않는 파일 형식",
		updated: "{item} 업데이트됨.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - 수출입업자 및 포워더를 위한 완전한 물류 관리 플랫폼. 실시간 선적 추적, 재고 관리, 인보이스 생성, 문서 자동화까지. 디지털 물류 솔루션으로 운영 시간을 40% 절감하세요. 무료로 사용해 보세요!",
		stock_feature:
			"Antrego로 재고 관리를 변혁하세요. 재고 관리, 공개 카탈로그 생성, 창고 간 배치 추적, 재고를 즉시 선적으로 전환. 수출업자와 제조사에 최적.",
		tracking_feature:
			"Antrego의 실시간 컨테이너 및 선적 추적. 실시간 업데이트, 자동 알림, 완전한 상태 이력, 다자 가시성 제공. 선적을 놓치지 마세요.",
		pdf_feature:
			"물류를 위한 전문 PDF 문서 생성기. 드래그 앤 드롭 에디터, 템플릿, 자동 데이터 채우기로 맞춤 인보이스와 프로포마 인보이스를 몇 분 만에 제작.",
		benefits_feature:
			"Antrego 플랫폼의 이점을 확인하세요. 중앙화 대시보드, 정확도 향상, 시간 효율, 팀 협업, 비용 절감, 확장성. 오늘 물류 운영을 혁신하세요.",
		contact:
			"Antrego에 문의하세요 - 질문, 데모, 지원 서비스를 위해 언제든 연락해 주세요. 귀사의 물류 운영 혁신을 돕겠습니다.",
		sign_in:
			"Antrego 로그인 - 선적 관리, 컨테이너 추적, 인보이스 생성, 팀 협업을 위한 물류 대시보드에 접속하세요. 안전한 로그인 포털.",
		sign_up:
			"Antrego 회원가입 - 물류 운영 관리를 시작할 무료 계정을 생성하세요. 월 10건 무료 선적 제공. 시작 시 신용카드가 필요 없습니다.",
	},
	$pageTitles: {
		accept_invitation: "초대 수락",
		benefits_feature: "플랫폼의 이점 - 완전한 물류 솔루션",
		company_profile: "회사 프로필",
		contact: "문의하기 - Antrego에 연락하기",
		home: "홈",
		landing_page: "모든 배송 프로세스를 디지털 방식으로 쉽게 관리하세요",
		partners: "파트너",
		pdf_editor: "PDF 편집기",
		pdf_feature: "PDF 문서 생성기 - 전문 인보이스",
		product_details: "제품 상세정보",
		product_groups: "제품 그룹",
		products: "제품",
		proforma_invoices: "견적서",
		shipment_details: "배송 세부 정보",
		shipments: "배송",
		sign_in: "로그인",
		sign_up: "가입",
		stock_details: "재고 세부사항",
		stock_feature: "재고 관리 - 재고 운영을 변혁",
		stocks: "재고",
		subscription: "구독",
		tracking_feature: "선적 추적 - 실시간 컨테이너 모니터링",
		user_profile: "사용자 프로필",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"등록되지 않은 파트너로, 이 플랫폼에서 그들의 프로필을 만들었습니다. 정보를 보고 편집할 수 있습니다.",
		createdHereTitle: "여기에서 생성됨:",
		description: "파트너와의 관계 상태를 추적할 수 있습니다. 차이점은 다음과 같습니다:",
		verifiedPartnersDescription:
			"이 파트너들은 초대를 수락하고 플랫폼에 등록했습니다. 정보는 읽기 전용이며 편집할 수 없습니다.",
		verifiedPartnersTitle: "검증된 파트너:",
	},
	$productGroup: {
		add_child: "자식 추가",
		add_new_product_group: "새 제품 그룹 추가",
		add_to_root: "루트에 추가",
		has_children_fail_message: "자식을 가진 제품 그룹은 삭제할 수 없습니다.",
		initial_message: "첫 번째 제품 그룹을 만들려면 이 {0} 버튼을 사용하세요.",
		name: "이름",
		number_of_product: "제품 수",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name}이(가) 승인됨.",
			create: "{name}에 의해 생성됨.",
			create_attachment: "{name}이(가) 첨부 파일을 생성함.",
			delete_attachment: "{name}이(가) 첨부 파일을 삭제함.",
			demand_revise: "{name}이(가) 수정 요청함.",
			mark_as_processed: "{name}이(가) 처리됨으로 표시됨.",
			reject: "{name}이(가) 거부됨.",
			revoke: "{name}이(가) 철회됨.",
			send: "{name}이(가) 수신자에게 평가를 위해 전송됨.",
			update: "{name}에 의해 업데이트됨.",
			update_attachment: "{name}이(가) 첨부 파일을 업데이트함.",
		},
		$actions: {
			approve: "승인",
			demand_revise: "수정 요구",
			mark_as_approved: "승인됨",
			mark_as_processed: "처리됨",
			mark_as_rejected: "거부됨",
			mark_as_revise_demanded: "수정 요구됨",
			mark_as_revoked: "철회됨",
			mark_as_sent: "전송됨",
			reject: "거부",
			revoke: "철회",
			send: "전송",
		},
		$status: {
			approved: "승인됨",
			pending_approval: "승인 대기 중",
			pending_revise: "수정 대기 중",
			processed: "처리됨",
			rejected: "거부됨",
			revoked: "철회됨",
			template: "템플릿",
		},
		approve_confirm_message: "견적서를 승인하시겠습니까?",
		approve_success_message: "견적서가 승인되었습니다.",
		demand_revise_description_message: "수정 기대사항에 대해 상세히 설명해 주세요:",
		demand_revise_success_message: "견적서가 발신자에게 수정 요청됨.",
		mark_as_processed_confirm_message: "견적서를 처리됨으로 표시하시겠습니까?",
		mark_as_processed_success_message: "견적서가 처리됨으로 표시되었습니다.",
		no_attachment_text: "첨부 파일이 아직 추가되지 않았습니다.",
		reject_confirm_message: "견적서를 거부하시겠습니까?",
		reject_success_message: "견적서가 거부되었습니다.",
		revoke_confirm_message: "견적서를 철회하시겠습니까?",
		revoke_success_message: "견적서가 철회되었습니다.",
		send_confirm_message: "견적서를 수신자에게 전송하시겠습니까?",
		send_success_message: "견적서가 전송되었습니다.",
	},
	$seoTitles: {
		landing_page: "Antrego | 물류 관리 소프트웨어 - 추적, 관리, 자동화",
		stock_feature: "재고 관리 소프트웨어 | 재고 추적 시스템 | Antrego",
		tracking_feature: "실시간 배송 추적 소프트웨어 | 컨테이너 추적 | Antrego",
		pdf_feature: "프로포마(견적) 송장 생성기 | 물류용 PDF 편집기 | Antrego",
		benefits_feature: "완전한 물류 플랫폼의 장점 | 올인원 솔루션 | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "이 모듈에 대한 구독이 이미 있습니다.",
		bad_request: "잘못된 요청",
		code_already_used: "코드가 이미 사용되었습니다.",
		container_status_not_available: "컨테이너 상태를 사용할 수 없습니다.",
		existing_email_warning: "이미 존재하는 이메일입니다.",
		existing_employee_error: "이 사용자는 이미 회사에 추가되었습니다.",
		existing_employee_for_email_warning: "이 이메일로 초대 코드가 이미 전송되었습니다.",
		existing_invitation_warning: "이 이메일로 초대 코드가 이미 전송되었습니다.",
		existing_token_already_have_time: "기존 토큰에 이미 사용할 시간이 충분합니다.",
		existing_user: "사용자가 이미 존재합니다.",
		five_min_reset_password_mail: "비밀번호 재설정 이메일을 요청한 후 최소 5분이 지나야 합니다.",
		forbidden: "금지됨",
		have_no_corporation: "회사가 없습니다.",
		have_no_custom_agency: "세관 기관이 없습니다.",
		have_no_employee: "직원이 없습니다.",
		instance_can_no_delete_existing_booking_code: "기존 예약 코드로 인해 인스턴스를 삭제할 수 없습니다.",
		instance_cannot_delete: "인스턴스를 삭제할 수 없습니다.",
		instance_not_found: "인스턴스를 찾을 수 없습니다.",
		internal_server_error: "내부 서버 오류",
		invalid_current_password: "현재 비밀번호가 잘못되었습니다.",
		invalid_identifier_or_password: "식별자 또는 비밀번호가 잘못되었습니다.",
		invalid_invitation_code: "초대 코드가 잘못되었습니다.",
		invalid_moving_request: "잘못된 이동 요청",
		invalid_operation: "잘못된 작업",
		invalid_refresh_token: "잘못된 새로 고침 토큰입니다.",
		invalid_unit: "잘못된 단위",
		invitation_accepting_is_due_to_the_admin: "초대 수락은 관리자에게 달려 있습니다.",
		invitation_already_discarded: "초대가 이미 폐기되었습니다.",
		invitation_already_used: "초대가 이미 사용되었습니다.",
		invitation_has_been_used: "초대가 사용되었습니다.",
		invitation_not_exist_email: "이메일 주소에 초대가 없습니다.",
		invitation_not_for_company: "이 초대는 회사를 위한 것이 아닙니다.",
		invitation_not_for_custom_agency: "이 초대는 세관 기관을 위한 것이 아닙니다.",
		invitation_not_found: "초대를 찾을 수 없습니다.",
		invitation_not_valid: "초대가 더 이상 유효하지 않습니다.",
		link_has_been_expired: "링크가 만료되었습니다.",
		link_not_be_used_anymore: "이 링크는 더 이상 사용할 수 없습니다.",
		missing_required_fields: "필수 필드가 누락되었습니다.",
		no_employee_found: "직원이 없습니다.",
		no_proper_partner_found: "적절한 파트너를 찾을 수 없습니다.",
		not_acceptable: "허용되지 않음",
		not_allowed_action: "이 작업을 수행할 권한이 없습니다.",
		not_allowed_use_api: "이 API를 사용할 권한이 없습니다.",
		not_found: "찾을 수 없음",
		not_have_purchase_subscription:
			"구독 플랜이 정의의 최대 한도에 도달했습니다. 더 추가하려면 구독 플랜 업그레이드를 고려해 주세요.",
		not_permitted_use_api: "이 API를 사용할 수 없습니다.",
		own_invitation_cannot_accept: "자신의 초대를 수락할 수 없습니다.",
		parent_group_not_found: "상위 그룹을 찾을 수 없습니다.",
		partnerId_required: "파트너 ID가 필요합니다.",
		partnership_already_exists: "파트너십이 이미 추가되었습니다.",
		password_cant_involve_space_char: "비밀번호에 공백 문자가 포함될 수 없습니다.",
		password_min_chars_least: "비밀번호는 최소 6자 이상이어야 합니다.",
		payment_required: "이 작업을 위해 구독이 필요합니다.",
		paytr_integration_error: "PayTR 통합 오류",
		ports_are_required: "포트가 필요합니다.",
		product_group_tree_not_found: "제품 그룹 트리를 찾을 수 없습니다.",
		proforma_invoice_action_not_available: "견적서 상태가 이 작업을 수행할 수 없습니다.",
		proforma_invoice_template_update: "견적서가 템플릿이어야 업데이트할 수 있습니다.",
		shipment_email_not_exist: "유효한 이메일을 입력하세요.",
		shipment_method_is_required: "배송 방법이 필요합니다.",
		shipping_term_is_required: "배송 조건이 필요합니다.",
		someone_else_uses_this_email: "다른 사람이 이 이메일 주소를 사용 중입니다.",
		someone_else_uses_this_username: "다른 사람이 이 사용자 이름을 사용 중입니다.",
		something_went_wrong: "문제가 발생했습니다.",
		type_can_be_abstract_company: '"유형" 속성은 "추상 회사"만 가능합니다.',
		unauthorized: "권한이 없음",
		undefined_result: "정의되지 않은 결과",
		unexpected_error_occurred: "예기치 않은 오류가 발생했습니다.",
		unit_already_added: "단위가 이미 추가되었습니다.",
		user_already_employee: "사용자가 이미 직원입니다.",
		user_already_exists: "사용자가 이미 회사에 있습니다.",
		user_does_not_exist: "사용자가 존재하지 않습니다.",
		user_not_found: "사용자를 찾을 수 없습니다.",
		username_min_chars_error: '"사용자 이름"은 최소 6자 이상이어야 합니다.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name}이(가) 차량을 추가했습니다.",
				delete_container: "{name}이(가) 차량을 삭제했습니다.",
				update_container: "{name}이(가) 차량을 업데이트했습니다.",
			},
			create: "{name}에 의해 생성됨.",
			create_attachment: "{name}이(가) 첨부 파일을 추가했습니다.",
			create_container: "{name}이(가) 컨테이너를 추가했습니다.",
			delete_attachment: "{name}이(가) 첨부 파일을 삭제했습니다.",
			delete_container: "{name}이(가) 컨테이너를 삭제했습니다.",
			update: "{name}에 의해 업데이트됨.",
			update_attachment: "{name}이(가) 첨부 파일을 업데이트했습니다.",
			update_container: "{name}이(가) 컨테이너를 업데이트했습니다.",
		},
		$containerStatus: {
			arrived: "도착",
			off_load: "하역 중",
			on_load: "적재 중",
			on_way: "이동 중",
			reserved: "예약됨",
		},
		$method: {
			aerial: "항공",
			land: "육상",
			railway: "철도",
			sea: "해상",
		},
		$vehicle: {
			license_number: "차량 번호판",
		},
		archiving_success_message: "배송이 보관되었습니다.",
		leave_message: "메시지 또는 의견을 남겨주세요",
		no_booking_info: "예약 정보가 아직 설정되지 않았습니다. {0} 버튼을 사용하세요.",
		no_transportation_info: "세부 정보가 아직 설정되지 않았습니다. {0} 버튼을 사용하세요.",
		un_archiving_success_message: "배송이 보관 해제되었습니다.",
	},
	$shortening: {
		number: "번호",
	},
	$socialMedia: {
		facebook: "페이스북",
		instagram: "인스타그램",
		linked_in: "링크드인",
		twitter: "트위터",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "구독을 갱신할 수 없습니다. 결제 방법을 확인하세요.",
			fail: "예기치 않은 오류가 발생했습니다. 나중에 다시 시도하세요. 문제가 지속되면 info@antrego.net으로 이메일을 보내 문제를 보고해 주세요.",
			ok: "구매 프로세스가 시작되었습니다. 프로세스 결과는 이메일로 알림을 받게 됩니다. 결제가 성공적으로 완료되면 구독이 시작됩니다.",
			payment_process_is_ongoing:
				"결제 프로세스가 진행 중입니다. 프로세스 결과는 이메일로 알림을 받게 됩니다. 결제가 성공적으로 완료되면 구독이 시작됩니다.",
			success: "구독이 성공적으로 생성되었습니다. Antrego를 쉽게 사용할 수 있습니다.",
			try_to_get_paid_again: "구독 기간이 만료되었습니다. 갱신하려면 여기를 클릭하세요.",
			unsubscribed: "구독이 취소되었습니다.",
			you_dont_have_any_subscription: "구독이 없습니다. 구독 페이지에서 패키지를 선택하고 쉽게 사용을 시작하세요.",
			you_dont_have_any_subscription_text: "계속하려면 요금제를 선택하세요.",
			you_dont_have_any_subscription_title: "활성 구독이 없습니다.",
		},
	},
	$unit: {
		acres: "에이커",
		boxes: "상자",
		centimeter: "센티미터",
		cubic_meter: "세제곱미터",
		dozen: "다스",
		feet: "피트",
		fluid_ounces: "액량 온스",
		gallons: "갤런",
		gram: "그램",
		hectare: "헥타르",
		inches: "인치",
		kilogram: "킬로그램",
		kilometer: "킬로미터",
		liter: "리터",
		meter: "미터",
		miles: "마일",
		milligram: "밀리그램",
		milliliter: "밀리리터",
		millimeter: "밀리미터",
		ounces: "온스",
		pallets: "팔레트",
		pieces: "조각",
		pounds: "파운드",
		quarts: "쿼트",
		square_feet: "제곱피트",
		square_inches: "제곱인치",
		square_kilometer: "제곱킬로미터",
		square_meter: "제곱미터",
		square_miles: "제곱마일",
		square_yards: "제곱야드",
		ton: "톤",
		yards: "야드",
	},
	$validation: {
		email: "유효한 이메일을 입력하세요.",
		invalid: "유효하지 않은 {item}",
		max_length: "{item}은(는) {length}자 이하여야 합니다.",
		min_length: "{item}은(는) {length}자 이상이어야 합니다.",
		must_length: "{item}은(는) {length}자여야 합니다.",
		only_number: "{item}은(는) 숫자여야 합니다.",
		password_repeat_warning: "비밀번호 확인이 새 비밀번호와 일치하지 않습니다.",
		required: "{item}이(가) 필요합니다.",
		required_for_default_language: "{item}은(는) 회사 기본 언어로 필요합니다.",
		you_must_approve_distance_sales_agreement: "원격 판매 계약을 승인해야 합니다.",
	},
	about: "정보",
	accept_invitation: "초대 수락",
	accept_invitation_success_message: "초대가 성공적으로 사용되었습니다.",
	accessibility: "접근성",
	actions: "작업",
	active: "활성화됨",
	activities: "활동",
	add: "추가",
	add_attribute: "속성 추가",
	add_from_stock: "재고에서 추가",
	add_images: "이미지 추가",
	add_item: "{item} 추가",
	add_manually: "여기에서 생성",
	add_new_employee: "새 직원 추가",
	add_new_packaging: "새 포장 추가",
	add_new_product: "새 제품 추가",
	add_new_stock: "새 재고 추가",
	add_new_warehouse: "새 창고 추가",
	add_stock_batch: "재고 배치 추가",
	add_template: "템플릿 추가",
	add_variant: "변형 추가",
	address: "주소",
	again: "다시",
	alert: "경고",
	already_have_employee_message: "이미 회사의 직원입니다.",
	amount: "금액",
	approve: "승인",
	archive: "보관",
	attachment: "첨부 파일",
	attachments: "첨부 파일들",
	attribute: "속성",
	attributes: "속성",
	auto_attached_pdf: "자동으로 첨부된 PDF",
	auto_detect: "자동 감지",
	available: "사용 가능",
	bank: "은행",
	basket: "장바구니",
	basket_empty: "장바구니가 비어 있습니다",
	batch: "배치",
	batch_no: "배치 번호",
	batches: "재고 배치",
	benefits: "혜택",
	billed_to: "청구 대상",
	booking: "예약",
	booking_code: "예약 코드",
	booking_details: "예약 세부정보",
	boolean: "불리언",
	business_partner: "사업 파트너",
	business_partners: "사업 파트너들",
	cancel: "취소",
	carrier: "운송업체",
	change_password: "비밀번호 변경",
	checking_invitation_code_message: "초대 코드를 확인하는 중",
	checkout: "결제하기",
	choose_image: "이미지 선택",
	choose_your_plan: "요금제 선택",
	clear: "지우기",
	clear_basket: "장바구니 비우기",
	click_to_play_the_video: "비디오 재생을 클릭하세요",
	close: "닫기",
	code: "코드",
	commercial: "상업",
	commercial_partner: "상업적 파트너",
	commercial_partners: "상업적 파트너들",
	companies: "회사들",
	company: "회사",
	company_address: "회사 주소",
	company_name: "회사 이름",
	company_profile: "회사 프로필",
	configuration: "설정",
	confirm: "확인",
	confirm_distance_selling_agreement: "원격 판매 계약을 확인하세요.",
	consult_us: "문의하기",
	contact: "연락처",
	contact_info: "연락처 정보",
	contact_text: "안심하세요. 최대한 빨리 연락드리겠습니다.",
	contact_title: "문의하세요, 프로세스를 간소화하세요.",
	contact_to_us: "문의하기",
	container: "컨테이너",
	container_no: "컨테이너 번호",
	containers: "컨테이너들",
	content: "내용",
	contract: "계약",
	copy_link: "링크 복사",
	corporation: "회사",
	countries: "국가들",
	country: "국가",
	create: "생성",
	create_a_new_account: "새 계정 생성",
	create_company: "회사 생성",
	create_document: "문서 만들기",
	create_shipment: "배송 생성",
	created_at: "생성됨",
	created_here: "여기에서 생성됨",
	credit_card_info: "신용 카드 정보",
	credit_card_no: "신용 카드 번호",
	currencies: "통화들",
	currency: "통화",
	current_password: "현재 비밀번호",
	current_plan: "현재 요금제",
	customer_company_address: "고객 회사 주소",
	customer_company_name: "고객 회사 이름",
	customs: "세관",
	customs_agencies: "세관 기관들",
	customs_agency: "세관 기관",
	cvv: "CVV",
	daily: "일일",
	damaged: "손상됨",
	dashboard: "대시보드",
	date: "날짜",
	date_input: "날짜 입력",
	day: "일",
	default: "기본",
	default_language: "기본 언어",
	delete: "삭제",
	delete_account: "계정 삭제",
	delete_confirm_message: "삭제를 확인하시겠습니까?",
	delete_document: "문서 삭제",
	delete_template: "템플릿 삭제",
	description: "설명",
	detail: "세부사항",
	dimensions: "치수",
	discard: "폐기",
	discover_all_benefits: "모든 이점 살펴보기",
	distance_sales_agreement: "원격 판매 계약",
	document: "문서",
	document_actions: "문서 작업",
	document_added: "문서가 추가되었습니다",
	document_creator: "문서 생성기",
	document_manager: "문서 관리자",
	document_name: "문서 이름",
	document_number: "문서 번호",
	document_overwrite: "편집 내용을 새 문서로 저장",
	document_save_info: "이 문서는 이 견적 송장 내에만 저장됩니다.",
	document_updated: "문서가 업데이트되었습니다",
	download: "다운로드",
	download_pdf: "PDF 다운로드",
	download_template: "템플릿 다운로드",
	edit: "편집",
	edit_attribute: "속성 편집",
	edit_description: "설명 편집",
	edit_document: "문서 편집",
	edit_item: "{item} 편집",
	edit_packaging: "포장 수정",
	edit_product: "제품 수정",
	edit_profile: "프로필 수정",
	edit_stock: "재고 편집",
	edit_stock_batch: "재고 배치 편집",
	edit_template: "템플릿 편집",
	edit_variant: "변형 편집",
	edit_your_profile_picture: "프로필 사진 수정",
	email: "이메일",
	employee: "직원",
	employee_type: "직원 유형",
	employees: "직원들",
	empty_data_warning:
		"이 영역에는 아직 데이터가 없습니다. 예제 데이터를 사용하여 플랫폼을 탐색하기 시작할 수 있습니다.",
	estimated_arrival_day: "예상 도착일",
	expense: "비용",
	expenses: "비용들",
	expires_at: "만료됨",
	explore_pdf_editor: "즉시 문서 만들기",
	explore_stock_management: "재고 관리 마스터하기",
	explore_tracking_features: "실시간으로 추적하기",
	exported_containers: "수출된 컨테이너들",
	fail: "실패",
	failed: "실패함",
	faq: "자주 묻는 질문",
	feedback: "피드백",
	file: "파일",
	file_name: "파일 이름",
	file_preview: "파일 미리보기",
	file_processing_error_message: "파일 처리 오류: {error}",
	file_read_error_message: "파일 읽기 오류",
	file_view: "파일 보기",
	filter: "필터",
	first_name: "이름",
	first_name_last_name: "이름 성",
	fixed_value: "고정 값",
	forget_password: "비밀번호 잊음",
	forget_password_message: "비밀번호를 잊으셨습니까?",
	forget_password_subtitle: "비밀번호를 재설정하려면 이메일 주소를 입력하세요.",
	format: "형식",
	free: "무료",
	from: "에서",
	general: "기본값",
	get_started_now: "지금 시작하기",
	give_us_feedback: "피드백 제공",
	go_to_panel: "패널로 이동",
	go_to_proforma: "견적으로 이동",
	go_to_shipment: "배송으로 이동",
	gross: "총",
	height: "높이",
	hide: "숨기기",
	hide_all: "모두 숨기기",
	home_page: "홈페이지",
	i_have_invitation_code: "초대 코드가 있습니다.",
	image_delete: "이미지 삭제",
	images: "이미지",
	import_excel: "Excel에서 가져오기",
	import_fail_message: "가져오기 실패: {error}",
	import_success_message: "{count}개의 제품을 성공적으로 가져왔습니다{skipped}.",
	imported_containers: "수입된 컨테이너들",
	in_progress: "진행 중",
	in_stock: "재고 있음",
	incoming: "수신됨",
	incoming_shipments: "수신된 배송들",
	initial: "초기",
	inputs: "내용",
	invitation: "초대",
	invitation_code: "초대 코드",
	invitation_mail_sent: "초대 이메일 전송됨",
	invitations: "초대들",
	invoice: "송장",
	invoice_no: "송장 번호",
	join: "가입",
	join_company: "회사에 가입",
	language: "언어",
	language_options: "언어 옵션",
	last_name: "성",
	last_one_year: "지난 1년",
	latitude: "위도",
	learn_more: "자세히 알아보기",
	left_a_comment: "댓글을 남겼습니다",
	length: "길이",
	link_copied: "링크가 복사되었습니다",
	link_copy_failed: "링크 복사 실패",
	loading_country: "출발 국가",
	loading_point: "출발 지점",
	loading_port: "출발 항구",
	log_in: "로그인",
	logo: "로고",
	longitude: "경도",
	lot_no: "로트 번호",
	mail_sent: "이메일 전송됨",
	make_visible: "표시 가능하게 하기",
	manage_profile: "프로필 관리",
	mass: "질량",
	measurements: "측정",
	merge_partner_description:
		"여기에서 생성된 회사는 Antrego에서 프로필을 생성할 때 기존 인증 파트너와 병합될 수 있습니다.",
	message: "메시지",
	message_company_create: "회사 생성됨.",
	message_company_join: "초대 코드를 입력하세요.",
	message_company_joined: "회사에 가입됨",
	message_employee_delete: "직원 삭제됨.",
	message_employee_save: "직원 저장됨.",
	message_join_company: "기존 회사에 가입하려면 코드를 입력하세요",
	method: "방법",
	migrate: "이동",
	migrate_partner: "파트너 이동",
	migrate_partner_description:
		"여기서 생성된 회사는 Antrego에 프로필을 생성할 때 기존의 검증된 파트너와 병합될 수 있습니다.",
	missing_product_group_sheet_message: "Excel 파일에 제품 그룹 시트가 없습니다",
	missing_product_sheet_message: "Excel 파일에 제품 시트가 없습니다",
	mobile_number: "휴대폰 번호",
	month: "월",
	month_lowercase: "월",
	monthly: "월간",
	multiple_select: "다중 선택",
	my_profile: "내 프로필",
	my_role: "내 역할",
	name: "이름",
	net: "순",
	new: "새로운",
	new_company_package: "무료",
	new_password: "새 비밀번호",
	new_shipment: "새로운 배송",
	next: "다음",
	no: "아니요",
	no_content: "내용 없음",
	no_entity: "엔터티 없음",
	no_entity_message: "엔터티를 찾을 수 없습니다.",
	no_image: "이미지를 찾을 수 없습니다",
	no_product_data_message: "Excel 파일에서 제품 데이터를 찾을 수 없습니다",
	no_product_group_data_message: "Excel 파일에서 제품 그룹 데이터를 찾을 수 없습니다",
	no_stock_batches_found: "재고 배치를 찾을 수 없습니다",
	no_stock_matches_filters: "선택한 필터에 맞는 재고가 없습니다.",
	no_stocks_added_yet: "아직 재고가 추가되지 않았습니다 — 선택하거나 추가해주세요.",
	no_text: "텍스트 없음",
	no_valid_products_message:
		"유효한 제품을 찾을 수 없습니다. 모든 제품은 기본 언어({language})로 된 이름이 있어야 합니다.",
	not_found_in_stock: "현재 필터로는 재고에서 제품을 찾을 수 없습니다.",
	not_found_page_message: "죄송합니다, 이 페이지를 찾을 수 없습니다 :(",
	not_set: "설정되지 않음",
	note: "노트",
	notes: "노트",
	number_of_rows: "행 수",
	ok: "확인",
	operation_fail: "작업 실패",
	option: "옵션",
	options: "옵션",
	other: "기타",
	out_of_stock: "재고 없음",
	outgoing: "발신됨",
	outgoing_shipments: "발신된 배송들",
	packages: "패키지들",
	packaging: "포장",
	packing_list_title: "포장 목록",
	parent_group: "상위 그룹",
	partner: "파트너",
	partners: "파트너들",
	partnership_status: "파트너십 상태",
	passive: "비활성화됨",
	password: "비밀번호",
	pay: "지불",
	payback: "환불",
	payback_confirm_message: "환불을 확인하시겠습니까?",
	payback_warning_message: "계속하면 구독이 종료됩니다.",
	payment: "결제",
	payment_amount: "결제 금액",
	payment_awaited: "결제 대기 중",
	payment_history: "결제 내역",
	payment_info: "결제 정보",
	payment_information: "결제 정보",
	payment_success: "결제 성공",
	payment_summary: "결제 요약",
	payment_will_be_made_3d_secure: "*결제는 3d 보안으로 이루어집니다.",
	pdf_attached_message: "PDF가 성공적으로 첨부되었습니다",
	pdf_editor: "PDF 편집기",
	pdf_name: "PDF 이름",
	pending_invitations: "보류 중인 초대",
	per_month: "월별",
	phone_number: "전화 번호",
	pieces: "조각",
	plate_numbers: "번호판",
	please_click_add_option: "옵션을 입력했지만 추가하지 않았습니다. 추가하거나 지워주세요.",
	prefix: "접두사",
	premium: "프리미엄",
	premium_plus: "프리미엄 플러스",
	preview: "미리보기",
	previous: "이전",
	price: "가격",
	pricing: "가격",
	process: "프로세스",
	product: "제품",
	product_details: "제품 상세정보",
	product_group: "제품 그룹",
	product_group_name: "제품 그룹 이름",
	product_group_not_found_message: '제품 그룹 "{group}"을(를) 찾을 수 없습니다. 코드 "{code}"의 제품은 건너뜁니다.',
	product_groups: "제품 그룹들",
	product_images: "제품 이미지",
	product_name: "제품 이름",
	products: "제품들",
	profile: "프로필",
	proforma_invoice: "견적서",
	proforma_invoices: "견적서들",
	proforma_number: "견적서 번호",
	proforma_options: "견적서 옵션",
	proforma_title: "견적 송장",
	purchase: "구매",
	quantity: "수량",
	quantity_warning: "이전에 재고 총합 값을 변경했기 때문에 합계가 자동으로 계산되지 않습니다.",
	ready_to_import: "가져올 준비 완료",
	receiver: "수신자",
	receiver_company: "수신 회사",
	receiver_customs_agency: "수신 세관 기관",
	redirection_to_home_link: "홈",
	redirection_to_home_message: "여기로 갈 수도 있습니다 ",
	redirection_to_sign_in_message: "계정이 있으신가요?",
	redirection_to_sign_up_message: "아직 계정이 없으신가요?",
	reload: "새로 고침",
	renewal: "갱신",
	repaid: "환불됨",
	reserved: "예약됨",
	reset_password: "비밀번호 재설정",
	returned: "반품됨",
	route: "경로",
	rows_per_page: "페이지당 행 수",
	sales: "판매",
	save: "저장",
	save_as_document: "문서로 저장",
	save_as_new_document: "새 문서로 저장",
	save_as_new_template: "새 템플릿으로 저장",
	save_as_template: "템플릿으로 저장",
	save_changes: "변경 사항 저장",
	save_pdf_to_attachments: "PDF를 첨부파일로 저장",
	saved_card_info: "저장된 카드 정보",
	search: "검색",
	select: "선택",
	select_a_file_to_preview: "미리보기할 파일을 선택하세요",
	select_document: "문서 선택",
	select_document_to_overwrite: "덮어쓸 문서 선택",
	select_file: "파일 선택",
	select_file_place_holder: "이미지를 선택하세요",
	select_language: "언어 선택",
	select_template: "템플릿 선택",
	select_template_to_overwrite: "덮어쓸 템플릿 선택",
	selected: "선택됨",
	selected_partner: "선택한 파트너",
	send: "전송",
	send_again: "다시 전송",
	send_email: "이메일 전송",
	send_feedback: "피드백 전송",
	send_invitation: "초대 전송",
	sender: "발신자",
	sender_company: "발신 회사",
	sender_customs_agency: "발신 세관 기관",
	separate_gross: "총 측정값 추가",
	settings: "설정",
	shipment: "배송",
	shipment_code: "배송 코드",
	shipment_details: "배송 세부정보",
	shipment_method: "배송 방법",
	shipment_type: "배송 유형",
	shipments: "배송들",
	shipments_filter: "배송 필터",
	shipped: "배송됨",
	shipping_term: "배송 조건",
	shipping_terms: "배송 조건들",
	show: "표시",
	show_all: "모두 표시",
	show_company_stock_page: "회사 재고 페이지 보기",
	show_in_stocks: "재고 페이지에 표시",
	sign_in: "로그인",
	sign_out: "로그아웃",
	sign_out_confirm_message: "로그아웃을 확인하시겠습니까?",
	sign_out_success_message: "안녕히 가세요.",
	sign_up: "가입",
	sizes: "크기",
	social_media: "소셜 미디어",
	social_media_account: "소셜 미디어 계정",
	start_time: "시작 시간",
	status: "상태",
	stock: "재고",
	stock_details: "재고 세부사항",
	stock_images: "재고 이미지",
	stock_status: "재고 상태",
	stocks: "재고",
	stocks_url: "재고 링크",
	subscribe: "구독",
	subscription: "구독",
	subscription_info_message: "구독 기간 동안 모든 서비스를 무제한으로 사용할 수 있습니다.",
	subscription_warning_message: "**카드 정보는 안전하게 저장되며 구독을 취소하지 않으면 정기적으로 갱신됩니다.",
	success: "성공",
	super: "슈퍼",
	supported_files_img: "지원되는 파일: JPG, PNG.",
	switch_language: "언어 전환",
	switch_theme: "테마 전환",
	table_inputs: "표 내용",
	target: "목표",
	target_partner: "목표 파트너",
	tax_number: "세금 번호",
	template: "템플릿",
	template_actions: "템플릿 작업",
	template_added: "템플릿이 추가되었습니다",
	template_name: "템플릿 이름",
	template_overwrite: "편집 내용을 새 템플릿으로 저장",
	template_save_info: "저장된 템플릿은 나중에 견적 송장 및 배송에 사용 가능합니다.",
	template_updated: "템플릿이 업데이트되었습니다",
	terms_of_sale_and_other_comments: "판매 조건 - 코멘트",
	text_input: "텍스트 입력",
	theme: "테마",
	this_month: "이번 달",
	this_year: "올해",
	title: "제목",
	to: "에게",
	toDelete: "삭제",
	total: "합계",
	total_amount: "총 금액",
	total_price: "총 가격",
	total_warning: "이 데이터를 변경하면 합계가 자동으로 계산되지 않습니다.",
	tracking: "선적 추적",
	transaction_no: "거래 번호",
	transactions: "거래",
	try_for_free: "무료로 시도",
	type: "유형",
	types: "유형들",
	un_archive: "보관 해제",
	unit: "단위",
	unit_price: "단가",
	units: "단위들",
	unloading_country: "도착 국가",
	unloading_point: "도착 지점",
	unloading_port: "도착 항구",
	unsubscribe: "구독 취소",
	unsubscribe_confirm_message: "구독을 취소하면 시스템 기능을 효과적으로 사용할 수 없습니다. 구독을 취소하시겠습니까?",
	upload_new_image: "새 이미지 업로드",
	use_code: "코드 사용",
	use_invitation_code: "초대 코드 사용",
	use_invitation_code_description: "메일함에 전송된 초대 코드를 입력하세요.",
	use_invitation_code_success_message: "초대 코드가 성공적으로 사용되었습니다.",
	user_profile: "내 프로필",
	value: "값",
	variant: "변형",
	variants: "변형",
	vehicle: "차량",
	vehicles: "차량들",
	verified_partner: "인증된 파트너",
	verify_password: "비밀번호 확인",
	visibility: "가시성",
	warehouse: "창고",
	warehouses: "창고들",
	warn_unsaved_measurement: "측정값을 추가하려면 '+'를 클릭하는 것을 잊지 마세요.",
	website: "웹사이트",
	week: "주",
	weight: "무게",
	weight_kg: "무게 (kg)",
	welcome: "환영합니다",
	what_we_are_doing: "우리가 하고 있는 일",
	width: "너비",
	year: "년",
	year_lowercase: "년",
	yearly: "연간",
	yes: "예",
	yes_no: "예 / 아니오",
	you_dont_have_any_active_subscription: "활성 구독이 없습니다.",
};
